var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 11.5859L1.14062 7.46094C0.929688 7.22656 0.929688 6.875 1.16406 6.66406C1.39844 6.45312 1.75 6.45312 1.96094 6.6875L4.9375 9.80469V1.8125C4.9375 1.50781 5.17188 1.25 5.5 1.25C5.80469 1.25 6.0625 1.50781 6.0625 1.8125V9.80469L9.01562 6.6875C9.22656 6.45312 9.60156 6.45312 9.8125 6.66406C10.0469 6.875 10.0469 7.22656 9.83594 7.46094L5.89844 11.5859C5.78125 11.7031 5.64062 11.75 5.5 11.75C5.33594 11.75 5.19531 11.7031 5.07812 11.5859Z",
    fill: "#D91734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowPercent);
export default __webpack_public_path__ + "static/media/downArrowPercent.6c4f3e675e35ec50736848caf3bc0246.svg";
export { ForwardRef as ReactComponent };